import { DateTime } from "luxon";
import React from "react";
import { Link } from "react-router-dom";
import "./FacultyGroup.css";
const bytesToSize = (bytes) => {
  const units = ["byte", "kilobyte", "megabyte", "terabyte", "petabyte"];
  const unit = Math.floor(Math.log(bytes) / Math.log(1024));
  return new Intl.NumberFormat("en", { style: "unit", unit: units[unit] }).format(bytes / 1024 ** unit);
}
const FacultyContent = (props) => {
  const data = props.data;
  let sectionNames = "";
  console.log(data);
  const secArray = Object.values(data.sections);
  const totalSecs = secArray.length;
  secArray.forEach((sec,ind) => {
      sectionNames += sec.name + ",";
  });
  sectionNames =  sectionNames.slice(0,-1);
  return (
    <div className="col-md-5 facultycontent p-2 mb-2 facultyContent" style={{ margin: "auto" }}>
      <Link to={`/files/${props.subject}/${props.section}/${props.batch}/${data.id}?category=${props.category}&exam=${props.exam}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="facultyabove p-2">
          <img
            src={data.img || "https://st.depositphotos.com/2101611/3925/v/600/depositphotos_39258143-stock-illustration-businessman-avatar-profile-picture.jpg"}
            alt="faculty"
            className="facultyProfile" style={{ width: "50px", height: "50px", borderRadius: "50%" }}
          ></img>
          <h3 className="mt-2 facultyName" style={{ marginLeft: "5px" }}>{data.name} </h3>
        </div>
        <div className="facultybelow">
          <h5 className="whitespace sections">Section: {sectionNames}</h5>
          <div>
        <div><h6 className="whitespace lastUpload">Last uploaded: {DateTime.fromISO(data.latestUpdated).toISODate()}</h6></div>  
    
          <div><h6 className="whitespace lastUpload">Total uploads  : {data.total}</h6></div>
          </div>
        </div>
         {/* TotalSize: {bytesToSize(data.totalSize)} uploaded <br />in this current subject of in all these sections of this batch</pre> */}
      </Link>
    </div>
  );
};

export default FacultyContent;
